import { render, staticRenderFns } from "./CourseSelection.vue?vue&type=template&id=1ae57782&scoped=true&"
import script from "./CourseSelection.vue?vue&type=script&lang=ts&"
export * from "./CourseSelection.vue?vue&type=script&lang=ts&"
import style0 from "./CourseSelection.vue?vue&type=style&index=0&id=1ae57782&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae57782",
  null
  
)

export default component.exports